import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { User } from "services/auth/types";

export const authAtom = atomWithStorage<User | undefined>("token", undefined);
export const menuKeyAtom = atomWithStorage<string[] | []>("menu_keys", []);

export const authAdminType = atom((get) => get(authAtom)!.admin_type);
